import React from "react";
import { Chip } from "@mui/material";

const HealthBadge = ({ healthy, label }) => (
    <Chip
        size="small"
        label={label || (healthy ? "Healthy" : "Unhealthy")}
        sx={{
            fontWeight: 600,
            bgcolor: healthy ? "rgba(16,185,129,0.12)" : "rgba(239,68,68,0.12)",
            color: healthy ? "#047857" : "#b91c1c",
        }}
    />
);

export default HealthBadge;
